import { IProduct } from '../../../../store/useProduct';
import ProductImageCard from './ProductImageCard';
import SkeletonProductCard from './SkeletonProductCard';

/**
 * @author kkakkuro0
 * @date 2024.10.08
 * @description 상품 카드 Row
 */
const ProductCardRow = ({ products }: { products: (IProduct | any)[] }) => {
  return (
    <>
      {products.map(product => {
        if (product.fake) {
          return <div key={product.id} className="!invisible"></div>;
        } else if (product.skeleton) {
          return <SkeletonProductCard key={product.id} />;
        } else {
          // IProduct를 IProductImage로 변환
          return <ProductImageCard key={product.id} {...product} />;
        }
      })}
    </>
  );
};

export default ProductCardRow;
